'use client';
import * as e from 'react';
import { merge } from './merge.js';
import { omit } from './omit.js';
import { useIsomorphicLayoutEffect } from '../../../hooks/use-isomorphic-layout-effect.js';
import { isNotProduction } from '../../../../core/utilities/env.utils.js';

function _define_property(e, r, t) {
    return r in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function _object_spread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {}, n = Object.keys(t);
        "function" == typeof Object.getOwnPropertySymbols && (n = n.concat(Object.getOwnPropertySymbols(t).filter(function(e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
        }))), n.forEach(function(r) {
            _define_property(e, r, t[r]);
        });
    }
    return e;
}
let o = isNotProduction(), i = 'object' == typeof window;
function createResponsiveSystem(r) {
    let { defaultScreenClass: a, breakpoints: l, cascadeMode: u = 'no-cascade' } = r;
    if (o) {
        let e = Object.values(l);
        if (e.length < 2) throw Error('ScreenClassConfigurationError - `breakpoints` must have at least 2 keys e.g. `{ mobile: 320, desktop: Infinity }`');
        if (1 !== e.filter((e)=>e === 1 / 0).length) throw Error('ScreenClassConfigurationError - `breakpoints` must have exactly 1 entry with a value of `Infinity` for the maximum pixel-width e.g. `{ mobile: 320, desktop: Infinity }`');
    }
    let c = Object.entries(l).sort(([, e], [, r])=>e > r ? 1 : 0), f = c.map(([e])=>e);
    function getMobileFirstScreenClasses(e) {
        return f.slice(0, f.indexOf(e) + 1);
    }
    function getDesktopFirstScreenClasses(e) {
        return f.slice(f.indexOf(e)).reverse();
    }
    let p = e.createContext(void 0), d = e.createContext(!1), { Provider: m } = p;
    function useScreenClass() {
        let r = e.useContext(p);
        if (void 0 === r) {
            if (o) throw Error("`useScreenClass` may only be used inside of a ScreenClassProvider. Make sure that you've rendered a ScreenClassProvider above this component your tree (usually folks render ScreenClassProvider near the root of their app). Returning the default screen class.");
            return a;
        }
        return r;
    }
    function useResponsiveProps(r) {
        let t = e.useContext(p);
        if (void 0 === t) {
            if (o) throw Error("`useResponsiveProps` may only be used inside of a ScreenClassProvider. Make sure that you've rendered a ScreenClassProvider above this component your tree (usually folks render ScreenClassProvider near the root of their app). Returning the default props with no overrides.");
            return omit(r, f);
        }
        let i = omit(r, f), a = [];
        switch(u){
            case 'mobile-first':
                a = getMobileFirstScreenClasses(t);
                break;
            case 'desktop-first':
                a = getDesktopFirstScreenClasses(t);
                break;
            default:
                a = [
                    t
                ];
        }
        return merge([
            i,
            ...a.map((e)=>{
                var t;
                return null !== (t = r[e]) && void 0 !== t ? t : {};
            })
        ]);
    }
    function responsive(r) {
        let t = e.forwardRef((t, n)=>{
            let s = useResponsiveProps(t);
            return e.createElement(r, _object_spread({
                ref: n
            }, s));
        });
        return t.displayName = void 0 !== r.displayName ? `Responsive(${r.displayName})` : 'ResponsiveComponent', t;
    }
    return {
        ScreenClassContext: p,
        ScreenClassProvider: ({ children: r })=>{
            let [n, s] = e.useState(a), [o, l] = e.useState(!1);
            return useIsomorphicLayoutEffect(()=>{
                if (!i) return;
                let e = c.map(([e, r], t)=>{
                    let n = t > 0 ? c[t - 1][1] + 1 : 0, o = [];
                    0 !== n && o.push(`(min-width: ${n}px)`), r !== 1 / 0 && o.push(`(max-width: ${r}px)`);
                    let i = o.join(' and '), a = window.matchMedia(i);
                    return a.matches && (s(e), l(!0)), [
                        e,
                        a
                    ];
                }), r = [];
                return e.forEach(([e, t])=>{
                    let listener = (r)=>{
                        r.matches && (s(e), l(!0));
                    };
                    t.addListener(listener), r.push([
                        t,
                        listener
                    ]);
                }), ()=>r.forEach(([e, r])=>e.removeListener(r));
            }, []), e.createElement(d.Provider, {
                value: o
            }, e.createElement(m, {
                value: n
            }, r));
        },
        useResponsiveProps,
        useScreenClass,
        useIsScreenClassInitialized: function() {
            return e.useContext(d);
        },
        responsive
    };
}

export { createResponsiveSystem };
